<template>
    <div class="diagram-detail-edit-panel" v-if="diagramData">
        <div class="diagram-d-e-title">起卦方式:<span class="sub">{{diagramData.f_type_str+(diagramData.f_type == 4 || diagramData.f_type == 5 || diagramData.f_type == 6 ? '：'+curDiagramInputNumber : '')}}</span></div>
        <div id="diagramDescribe" class="diagram-d-e-title p-t-10">占卦描述:</div>
        <diagram-edit-panel
            v-bind:fromShare="diagramFromShare"
            v-bind:textKey="'f_describe'"
            v-bind:textValue="diagramData.f_describe"
            v-bind:placeholderText="'可以补充详细占卦的背景及相关信息'"
            v-bind:saveFunc="saveDiagramDetail">
        </diagram-edit-panel>
        <div id="diagramAnalyse" class="diagram-d-e-title">断卦分析:</div>
        <diagram-edit-panel
            v-bind:fromShare="diagramFromShare"
            v-bind:textKey="'f_analyse'"
            v-bind:textValue="diagramData.f_analyse"
            v-bind:placeholderText="'卦象分析可以写在这里'"
            v-bind:saveFunc="saveDiagramDetail">
        </diagram-edit-panel>
        <div class="diagram-d-e-title">结果反馈:
            <span v-if="!diagramFromShare" class="diagram-d-e-sub-edit">
                <input class="diagram-d-e-sub-edit-input" type="file" id="profile_pic" name="profile_pic" accept=".jpg, .jpeg, .png" multiple @change="changeInput" />
                <i class="iconfont icon-expand"></i><span class="text">上传论卦及反馈相关多图</span>
            </span>
        </div>
        <div id="diagramFeedBack" class="diagram-d-e-img-box clearfix">
            <div class="diagram-d-e-img-item" v-for="(dImg, dIndex) in diagramData.f_fb_img_arr">
                <img class="diagram-d-e-img-img" :src="dImg" alt="" object-fit="cover" @click="clickImg(dIndex)">
                <div v-if="!diagramFromShare" class="diagram-d-e-img-delete" @click="clickDeleteFbImg(dIndex)"><i class="iconfont icon-close-solid"></i></div>
            </div>
        </div>
        <diagram-edit-panel
            v-bind:fromShare="diagramFromShare"
            v-bind:textKey="'f_feedback'"
            v-bind:textValue="diagramData.f_feedback"
            v-bind:placeholderText="'无'"
            v-bind:saveFunc="saveDiagramDetail"
            v-bind:editClassName="'edit_feedback'">
        </diagram-edit-panel>
        <div class="diagram-d-e-title-box dsp-flex">
            <div class="diagram-d-e-title">结果定案:</div>
            <div class="diagram-d-e-label">
                <span class="e-label e-l-one" :class="{'on': diagramData.f_fb_status == 1}" @click="toggleFeedBack(1)">神断</span>
                <span class="e-label e-l-two" :class="{'on': diagramData.f_fb_status == 2}" @click="toggleFeedBack(2)">大部分对</span>
                <span class="e-label e-l-three" :class="{'on': diagramData.f_fb_status == 3}" @click="toggleFeedBack(3)">失手了</span>
            </div>
        </div>
        <div id="diagramReview" class="diagram-d-e-title">复盘分析:</div>
        <diagram-edit-panel
            v-bind:fromShare="diagramFromShare"
            v-bind:textKey="'f_review'"
            v-bind:textValue="diagramData.f_review"
            v-bind:placeholderText="'复盘分析可以写在这里'"
            v-bind:saveFunc="saveDiagramDetail">
        </diagram-edit-panel>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils'
import { API_POST } from '../../modules/api';
import DiagramEditPanel from './DiagramEditPanel.vue';
export default {
    name: 'DiagramDetailEditPanel',
    components: { DiagramEditPanel },
    computed: {
        diagramData() {
            return this.$store.state.diagram.diagramData;
        },
        diagramFromShare() {
            return this.$store.state.diagram.diagramFromShare;
        },
        curDiagramInputNumber() {
            return this.$store.state.diagram.curDiagramInputNumber;
        }
    },
    data() {
        return {
            UTILS: UTILS,
            describeEdit: false,
            analyseEdit: false,
            feedbackEdit: false,
            reviewEdit: false,
            tempIndex: 0,
            tempFiles: [],
            urlList: []
        }
    },
    methods:{
        changeInput(e) {
            this.tempIndex = 0;
            this.tempFiles = e.target.files;
            console.log('changeInput-----', e.target.files)

            if(e.target.files && e.target.files.length == 0) {
                this.$toast("图片选择失败");
                return;
            }
            this.upLoadChoosedImg();
        },
        upLoadChoosedImg() {
            let file = this.tempFiles[this.tempIndex];
            API_POST.uploadFile({
                paramsStr: 'type=gua',
                file: file
            }, (data) => {
                if(!data) {
                    this.$toast('上传图片出错,请稍后再试')
                    return;
                }
                this.urlList.push(data.url);
                if(this.tempIndex < this.tempFiles.length-1) {
                    this.tempIndex++;
                    this.upLoadChoosedImg();
                }else {
                    // 更新信息
                    this.$store.dispatch('diagram/updateDiagramFbImg', {
                        params: { type: 'add', urlList: this.urlList },
                        sucCb: ()=> {
                            console.log('success----', this.tempIndex, this.tempFiles, this.urlList)
                            this.tempIndex = 0;
                            this.tempFiles = [];
                            this.urlList = [];
                        }
                    });
                }
            });
        },
        clickImg(imgIndex) {
            console.log('clickImg-----', imgIndex);
            this.$store.state.diagram.showDetailImgPanel = true;
            this.$store.state.diagram.diagramDetailChoosedImgIndex = imgIndex;
        },
        clickDeleteFbImg(index) {
            // console.log('clickDeleteFbImg---', index)
            this.$bus.emit('showDeleteRecordItemPop', {
                text1: '确定要删除这一张图片吗？',
                cb: () => {
                    this.$store.dispatch('diagram/updateDiagramFbImg', {
                        params: { type: 'delete', index: index }
                    });
                }
            })
        },
        toggleFeedBack(fb) {
            // console.log('toggleFeedBack------', fb)
            if(this.diagramFromShare) {
                return;
            }
            this.$store.dispatch('diagram/saveDiagramEdit', {
                type: 'detail', key: 'f_fb_status', value: fb
            });
        },
        saveDiagramDetail(key, value, cb) {
            console.log('saveDiagramDetail----', key, value)
            this.$store.dispatch('diagram/saveDiagramEdit', {
                type: 'detail', key: key, value: value,
                sucCb: cb
            });
        }
    }
}
</script>
